// extracted by mini-css-extract-plugin
export default {"NotFound":"styles_NotFound__Q4VPq"};